import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AdminApp } from './AdminApp';
import { LandingPage } from './LandingPage';
import './styles.css';

const isAdmin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');
createRoot(document.getElementById('root')!).render(<StrictMode>{isAdmin ? <AdminApp /> : <LandingPage />}</StrictMode>);
